import {connect} from 'react-redux'

import type {State} from '../../../../../reducers/types'
import {getBuild, getBuildType} from '../../../../../selectors'
import {parseBranch} from '../../../../../utils/branchNames'

import Deployment from './Deployment'
import type {ActionCreators, OwnProps, StateProps} from './Deployment.types'
import {fetchLastDeployedBuild} from './Deployments.actions'
import {getDeploymentId, getIsObsolete, getLastDeployedBuildId} from './Deployments.selectors'

const actionCreators: ActionCreators = {
  fetchLastDeployedBuild,
}

const mapStateToProps = (
  state: State,
  {buildId, buildTypeId, deployTypeId, artifactOnly}: OwnProps,
): StateProps => {
  let branch = null

  if (!artifactOnly) {
    const {branchName, defaultBranch} = getBuild(state, buildId) ?? {}

    if (!defaultBranch) {
      branch = parseBranch(branchName)
    }
  }

  const deploymentId = getDeploymentId(state, buildId, deployTypeId)
  const deploymentBuild = getBuild(state, deploymentId)
  const lastDeployedBuildConfig = {
    buildTypeId,
    branch,
    deployTypeId,
  }
  return {
    branch,
    isObsolete: getIsObsolete(state, buildId, lastDeployedBuildConfig),
    deploymentId,
    lastDeployedBuildId: getLastDeployedBuildId(state, lastDeployedBuildConfig),
    deploymentState: deploymentBuild?.state,
    deployTypeInternalId: getBuildType(state, deployTypeId)?.internalId,
  }
}

export default connect(mapStateToProps, actionCreators)(Deployment)
